import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { LoginService } from '../home/login.service';
import { IOnlineOrder } from './onlineorder';
import { ICartItems } from './cartitems';
import { IProduct } from '../products/product';
import { ToastrService } from 'ngx-toastr';
import { APIResult } from '../home/apiResult';
import { IOrderTotals } from './ordertotals';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from '../admin/admin.service';
import { TranslateService } from '@ngx-translate/core';
import { Buffer } from 'buffer';
@Injectable()
export class OrderService {
  public token!: string;
  public orderID!: number;
  public tempCart!: ICartItems[];
  public cart = [];
  public BalanceDue!: number;
  public TaxTotal!: number;
  public apiRes!: APIResult;
  public BalanceDue2!: number;
  public TaxTotal2!: number;
  public currentUser: any;
  public lbriAPI: any;
  public orderTotals!: IOrderTotals;
  public onlineOrder: IOnlineOrder[] = [];

  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  constructor(
    private _http: HttpClient,
    private login: LoginService,
    public toaster: ToastrService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService
  ) {
    //this.cart = new Array<ICartItems>();
  }

  private _orderUrl!: string;
  private _orderUrl2!: string;
  private getTotalsUrl!: string;
  private _clearOrder!: string;

  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  // addItemError(): void {

  //     this.toaster.error("You can only add one of each sample to your cart!", "Error",  {
  //         timeOut: 3000
  //     });
  // }
  // moreThanOneSampleError(): void{
  //     this.toaster.error("You can only order one sample set per order", "Error",  {
  //         timeOut: 3000
  //     });
  // }
  // addItemAlreadyOrderedError(): void {

  //     this.toaster.error("You have already ordered this item in the past, you can only order one free sample set " +
  //     "of each kind in your lifetime.", "Error",  {
  //             timeOut: 3000
  //         });
  // }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  clearOrderSync() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this._clearOrder =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrder/Clear?onlineOrderId=' +
      this.orderID;
    let xhr = new XMLHttpRequest();
    xhr.open('POST', this._clearOrder, false);
    xhr.setRequestHeader(
      'Authorization',
      'Bearer ' + this.currentUser.access_token
    );
    xhr.send();
    // let headers = new Headers({
    //     'scope': 'write',
    //     // 'content-type': 'application/x-www-form-urlencoded'
    //     'Authorization': "Bearer " + this.currentUser.access_token
    // });
    // let options1 = new RequestOptions({
    //     headers: let headers
    // });

    // this.orderID = currentOrderID.ID;

    // return this._http.post(this._clearOrder, let _body, let options1)
    //     .map((response: Response) => response.json())
    //     //.do(data => console.log('All: ' +  JSON.stringify(data)))
    //     .catch(this.handleError);
  }

  mergeToOrder(i: number) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let _body = {};
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;

    //console.log("i's place: " + + " length: " +this.cart.length)
    this._orderUrl =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrderDetail';
    this._orderUrl +=
      '?onlineOrderId=' +
      this.orderID +
      '&productId=' +
      this.cart[i].ProductId +
      '&quantity=' +
      this.cart[i].Quantity +
      '&shouldCalculateTax=true';
    return this._http
      .post(this._orderUrl, null, options1)
      .pipe(catchError(this.handleError));
  }

  // mergeToOrder(i: number) {
  //     this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
  //     this.currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
  //     let _body = {
  //         "ProductId": this.cart[i].productId,
  //         "Quantity": this.cart[i].quantity
  //     };
  //     let headers = new HttpHeaders({
  //         'scope': 'write',
  //          'content-type': 'application/json',
  //         'Authorization': "Bearer " + this.lbriAPI.access_token
  //     });
  //     let options1 = {
  //         headers: headers
  //     };

  //     var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
  //     this.orderID = currentOrderID.ID;

  //     //console.log("i's place: " + i + " length: " +this.cart.length)
  //     this._orderUrl = 'https://samplecart.lbri.net/api/api/OnlineOrderAddItem/' + this.orderID;
  //   //  this._orderUrl += "?onlineOrderId=" + this.orderID + "&productId=" + this.cart[i].productId + "&quantity=" + this.cart[i].quantity;
  //     return this._http.post(this._orderUrl, _body, options1)
  //     .pipe(
  //         catchError(this.handleError)
  //     )
  //         // .map((response: Response) => response.json())
  //         // //.do(data => console.log('All: ' +  JSON.stringify(data)))
  //         // .catch(this.handleError);
  // }

  checkIfOrdered2(sku: string) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };
    let _body = {
      customerDID: this.currentUser.userName.replace('-->c_', ''),
      productID: sku,
      startDate: 1 / 1 / 1990,
    };

    this._clearOrder =
      'https://webapi.securefreedom.com/Lbri/API/Order/Order/CustomerItemOrderedSinceDate?customerDID=' +
      this.currentUser.userName.replace('-->c_', '') +
      '&productID=' +
      sku +
      '&startDate=1/1/1990';
    return this._http
      .get(this._clearOrder, options1)
      .pipe(catchError(this.handleError));
    // .map((response: Response) => response.json())
    // .do(data => console.log('All: ' +  JSON.stringify(data)))
    // .catch(this.handleError);
  }

  deleteItem(item: ICartItems) {
    this.cart = this.cart.filter(
      (cartItem) => cartItem.productId !== item.ProductId
    );
    return this.cart;
  }
  clearCart(isLogout: boolean) {
    var currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    this.login.token = currentUser && currentUser.access_token;
    if (this.login.loggedIn()) {
      this.cart = [];
      localStorage.removeItem('cartItems');
      this.clearOrder().subscribe(
        (order: any) => console.log(order),
        (error: any) => console.log(error),
        () => {
          if (!isLogout) this.updateShipMethodPlusTotals2().subscribe();
        }
      );
    } else {
      localStorage.removeItem('cartItems');
      this.cart = [];
    }
  }

  public addItem(item: ICartItems) {
    if (this.cart.length > 0) {
      if (
        this.cart.filter((cartItem) => cartItem.productId == item.ProductId)
          .length >= 1
      ) {
        //console.log(this.tempCart = this.cart.filter(cartItem => cartItem.productId == item.productId));

        this.showError(
          'products.toastPopups.errors.oneOfEach',
          'products.toastPopups.errors.titles.title1',
          true
        );

        //this.addItemError();
        return false;
        // this.tempCart = this.cart.filter(cartItem => cartItem.productId == item.productId);
        // this.tempCart.forEach(item1 => {
        //     item1.quantity+=1;
        //     item.quantity = item1.quantity;

        // });
        // this.deleteItem(item);
        // this.tempCart = [];
      } else {
        var testCart = [];
        // console.log(testCart);
        // console.log(this.cart);
        if (Array.isArray(this.cart)) this.cart.push(item);
        //console.log(this.cart);
        return true;
      }
      //this.cart.push(item);
      //console.log(this.cart);
    } else {
      var testCart = [];
      //console.log(testCart);
      this.cart = testCart;
      //console.log(this.cart);
      if (Array.isArray(this.cart)) this.cart.push(item);
      //console.log(this.cart);
      return true;
    }
  }

  public getCart(): ICartItems[] {
    return this.cart;
  }

  // addToOrder(sku: string):Observable<IOnlineOrder[]> {
  //     this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
  //     this.currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
  //     let mybody =
  //     {
  //         "ProductId": sku,
  //         "Quantity": 1
  //     };
  //     let headers1 = new HttpHeaders({
  //         'scope': 'write',
  //         'content-type': 'application/json',
  //         'Authorization': "Bearer " + this.lbriAPI.access_token
  //     });
  //     let options1 ={
  //         headers: headers1
  //     };

  //     var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
  //     this.orderID = currentOrderID.ID;
  //     this._orderUrl = 'https://samplecart.lbri.net/api/api/OnlineOrderAddItem/' + this.orderID;
  //     //this._orderUrl = 'http://localhost/webapitest/api/OnlineOrderAddItem/' + this.orderID;

  //     return this._http.post<IOnlineOrder[]>(this._orderUrl, mybody, options1)
  //     .pipe(
  //         map(data => this.onlineOrder = data),
  //         catchError(this.handleError)
  //     );
  //         // .map((response: Response) => response.json())
  //         // .do(data => console.log('All: ' +  JSON.stringify(data)))
  //         // .catch(this.handleError);
  // }
  addToOrder(sku: string) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let _body = {
      name: null,
      value: null,
    };
    var myCreds = Buffer.from('postcardapi:6TfC5RdX$$', 'utf8').toString(
      'base64'
    );
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Basic ' + myCreds,
      //'Authorization': "Bearer " + this.currentUser.access_token
    });
    let options1 = {
      headers: headers,
    };

    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;
    this._orderUrl =
      'https://webapi.bydesign.com/Lbri/api/order/OnlineOrderDetail';
    this._orderUrl +=
      '?onlineOrderId=' +
      this.orderID +
      '&productId=' +
      sku +
      '&quantity=1&shouldCalculateTax=true';
    return this._http
      .post<IOnlineOrder[]>(this._orderUrl, null, options1)
      .pipe(catchError(this.handleError));
  }

  // createOnlineOrder() {
  //     this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
  //     this.currentUser = JSON.parse(localStorage.getItem('authorizationData') || '{}');
  //     let _body = {
  //         "CustomerNumber": this.login.getCustId().replace('-->c_', '')
  //     };
  //     let headers = new HttpHeaders({
  //         'scope': 'write',
  //         'content-type': 'application/json',
  //         'Authorization': "Bearer " + this.lbriAPI.access_token
  //     });
  //     let options1 = {
  //         headers: headers
  //     };

  //     this._orderUrl = 'https://samplecart.lbri.net/api/api/CreateOnlineOrder/';
  //     //this._orderUrl = 'http://localhost/webapitest/api/CreateOnlineOrder/';

  //     return this._http.post<number>(this._orderUrl, _body, options1)
  //     .pipe(
  //          //map((data:number) => console.log(data)),
  //         tap((data:number) => {
  //             let orderID = data
  //             if (orderID) {
  //                 this.orderID = orderID;
  //                 localStorage.setItem('orderId', JSON.stringify({ ID: this.orderID }))
  //                 return this.orderID;
  //             }
  //             return null;
  //         }),
  //         catchError(this.handleError)
  //     );
  //         // .map((response: Response) => {
  //         //     let orderID = response.json();
  //         //     if (orderID) {
  //         //         this.orderID = orderID;
  //         //         localStorage.setItem('orderId', JSON.stringify({ ID: this.orderID }))
  //         //         return this.orderID;
  //         //     }
  //         // })
  //         // .do(data => console.log('All: ' +  JSON.stringify(data)))
  //         // .catch(this.handleError);
  // }

  updateShipMethodPlusTotals2() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );

    let headers = new HttpHeaders({
      scope: 'write',
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    this.getTotalsUrl =
      'https://webapi.securefreedom.com/Lbri/API/Order/OnlineOrder/';
    let _body = {};
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;

    return this._http
      .put<IOrderTotals>(
        this.getTotalsUrl +
          this.orderID +
          '/UpdateShipMethod?ShipMethodID=1001',
        _body,
        options1
      )
      .pipe(
        map((data) => (this.orderTotals = data)),
        tap((data) => {
          let BalanceDue = data.balanceDueField;
          let BalanceDue2 = data.balanceDue;
          let TaxTotal = data.taxTotalField;
          let TaxTotal2 = data.taxTotal;
          //console.log("???? " + BalanceDue);

          this.BalanceDue = BalanceDue;
          this.TaxTotal = TaxTotal;
          this.BalanceDue2 = BalanceDue2;
          this.TaxTotal2 = TaxTotal2;

          localStorage.setItem(
            'orderInfo',
            JSON.stringify({
              balanceDueField: this.BalanceDue,
              taxTotalField: this.TaxTotal,
              BalanceDue: this.BalanceDue2,
              TaxTotal: this.TaxTotal2,
            })
          );
          if (this.BalanceDue !== undefined) {
            return (
              'Get Balance Due: ' +
              this.BalanceDue +
              'Get Tax: ' +
              this.TaxTotal
            );
          } else {
            return (
              'Get Balance Due: ' +
              this.BalanceDue2 +
              'Get Tax: ' +
              this.TaxTotal2
            );
          }
        }),
        catchError(this.handleError)
      );
  }

  clearOrder(): any {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    let _body = {};

    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    this.orderID = currentOrderID.ID;
    this._clearOrder =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrder/Clear?onlineOrderId=' +
      this.orderID;
    return this._http.post(this._clearOrder, _body, options1).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError)
    );
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
